import theme from "@/theme";

// Theme colors
export const themeColors = {
  primary: theme.palette.primary[700] || "#1976d2", // blue
  error: theme.palette.error.main || "#d32f2f", // red
  warning: theme.palette.secondary[900] || "#f57c00", // amber
  success: theme.palette.accent1[700] || "#1b5e20", // green
};

// Derived colors for backgrounds (lighter versions)
export const backgroundColors = {
  errorLight: theme.palette.error[50] || "#ffebee",
  warningLight: theme.palette.secondary[50] || "#fff3e0",
  successLight: theme.palette.accent1[50] || "#e8f5e9",
  grayLight: theme.palette.grey[50] || "#f5f5f5",
};

// Helper function to lighten a hex color
export const lightenColor = (color: string, amount: number = 0.7): string => {
  const colorMap: { [key: string]: string } = {};
  colorMap[themeColors.error] = theme.palette.error[300] || "#ef9a9a";
  colorMap[themeColors.warning] = theme.palette.secondary[300] || "#ffb74d";
  colorMap[themeColors.success] = theme.palette.accent1[300] || "#81c784";
  colorMap[themeColors.primary] = theme.palette.primary[300] || "#64b5f6";

  return colorMap[color] || theme.palette.grey[300] || "#B8D4D4";
};
